import Modal from 'react-bootstrap/Modal';

interface ConfirmPopupProps {
    heading: string;
    text: string;
    showConfirmModal: boolean;
    hideConfirmModal(): void;
    saveConfirmModal(): void;
}

const ConfirmPopups = (props: ConfirmPopupProps) => {

    const hideConfirmModal = () => {
        props.hideConfirmModal();
    }

    const saveConfirmModal = () => {
        props.saveConfirmModal();
    }

    return (
        <Modal size="sm" show={props.showConfirmModal} onHide={hideConfirmModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>{props.heading}</Modal.Title>
                <button type="button" className="close" onClick={hideConfirmModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p>{props.text}</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--no" onClick={hideConfirmModal}>No</button>
                <button className="popup-button--yes" onClick={saveConfirmModal}>Yes</button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmPopups;